import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["dateTimeField", "dateField", "timeField"];
  }

  connect() {
    this.updateDateFieldTime();
  }

  updateDateFieldTime() {
    if (!this.dateFieldTarget.value && !this.timeFieldTarget.value) {
      return;
    }

    this.dateTimeFieldTarget.value = this.dateTime;
  }

  get dateTime() {
    if (!this.dateTimeObject) {
      return null;
    }

    return new Date(Date.UTC(
      this.dateTimeObject.getFullYear(),
      this.dateTimeObject.getMonth(),
      this.dateTimeObject.getDate(),
      this.dateTimeObject.getHours(),
      this.dateTimeObject.getMinutes()
    )).toUTCString();
  }

  get dateTimeObject() {
    if (!this.dateFieldTarget.value) {
      return null;
    }

    return new Date(`${this.dateFieldTarget.value} ${this.timeFieldTarget.value}`);
  }
}
